import { STATE, MUTATIONS } from "./names";

export default {
    [MUTATIONS.SET_WRONG_WALLET_MODAL_DATA](state, { show, address }) {
        state[STATE.WRONG_WALLET_MODAL_VISIBLE] = show;
        state[STATE.WRONG_WALLET_MODAL_ADDRESS] = address;
    }
}
